import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_DURATION_MS = 400;

export function useMinDurationLoading(durationMs = DEFAULT_DURATION_MS) {
  const [isLoading, setIsLoading] = useState(false);
  const startTimeRef = useRef<number | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const start = useCallback(() => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    startTimeRef.current = Date.now();
    setIsLoading(true);
  }, []);

  const stop = useCallback(() => {
    const elapsed = startTimeRef.current !== null ? Date.now() - startTimeRef.current : durationMs;
    startTimeRef.current = null;
    const remaining = Math.max(0, durationMs - elapsed);
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
    }
    if (remaining > 0) {
      timerRef.current = setTimeout(() => {
        setIsLoading(false);
      }, remaining);
    } else {
      setIsLoading(false);
    }
  }, [durationMs]);

  useEffect(() => {
    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return { isLoading, start, stop };
}
